import * as React from 'react';
import { G } from 'react-native-svg';
import Turtle from './Turtle';

function TurtlePreview() {
  return (
    <G opacity={0.1}>
      <Turtle />
    </G>
  );
}

export default TurtlePreview;
